import { DESKTOP_MENU_HEIGHT, MOBILE_MENU_HEIGHT, SMALL_MENU_HEIGHT } from '../../constants';

export const withOffset = {
    mobileHeight: MOBILE_MENU_HEIGHT,
    desktopHeight: DESKTOP_MENU_HEIGHT,
};

export const withoutOffset = {
    mobileHeight: SMALL_MENU_HEIGHT,
    desktopHeight: SMALL_MENU_HEIGHT,
};
